module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 12\">\n  <polygon points=\"5.8 6.3 5.8 0 3.2 0 3.2 6.3 0 6.3 4.5 12 9 6.3 \" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-down.svg
// module id = 889
// module chunks = 0